// @ts-ignore
import React, { useState, useEffect } from 'react';
import { MyPATExpansionPanel } from '../../../common';
import { Theme, Typography, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AddDifficultyAndSkill from './AddDifficultyAndSkill';
import getDefaultFormData from '../../types/ContentFromDataDefault';
import { convertSubjectIdFromObjectToString, createDeepCopy, getPropertyValue, getTimerStateForIdealTime } from '../../../../utils';
import { connect } from 'react-redux';
import SetIdealTime from './SetIdealTime';
import RelevantExams from './RelevantExams';
import AddBenchmarking from './AddBenchmarking';
import PreviousYearQuestion from './PreviousYearQuestion';
import AddExtraTags from './AddExtraTags';
import { questionActions } from '../../reducers/questionCreateReducer';
import { CONTENT_TYPE, DEFAULT_IDEAL_TIME, QUESTION_TYPES, REGEX_FOR_NUMBER } from '../../../../constants/comman';
import contentActions from '../../actions/contentActions';
import contentService from '../../services/contentService';
import QuestionSlider from './QuestionSlider';
import { convertTime } from '../../../../utils/getOffset.utils';
import AddConceptOrChapter from './AddConceptOrChapter';


const styles = (theme: Theme) =>
    createStyles({
        heading: {
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: ' 28px',
            textAlign: 'left',
        }
    });

function ValidatorFields(props: any) {
    const { classes, contentData, updateQuestionBenchmarks, submitValidatorRef, setValidatorMandatoryFields, setRelevantExams } = props
    const [questionDataList, setQuestionDataList] = useState([contentData]);
    const [benchMarking, setBenchMarking] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [idealTime, setIdealTime] = useState(DEFAULT_IDEAL_TIME);
    const questionData = questionDataList[selectedIndex];
    const [counter, setCounter] = useState(0);
    const isParagraphQuestion = QUESTION_TYPES.PARAGRAPH === +contentData.contentSubTypeCode;
    const questionId = questionData['_id'];
    const setQuestionData = (questionData: any) => {
        const newQuestionList = createDeepCopy(questionDataList);
        newQuestionList[selectedIndex] = {
            ...(newQuestionList[selectedIndex] || {}),
            ...(questionData || {})
        }
        setQuestionDataList(newQuestionList);
    }
    const [showConceptAndChapter,setShowConceptAndChapter] =useState(false);
    const checkForMandatoryFields = () => {
            const filledMandatoryFields = (questionDataList || []).every((contentDataDetails: any) =>
                getPropertyValue(contentDataDetails, 'difficultyType.length') && getPropertyValue(contentDataDetails, 'difficultyLevel.length') && getPropertyValue(contentDataDetails, 'subjects.length'))
        setValidatorMandatoryFields(filledMandatoryFields);
    }

    const setDifficultyAndSkill = (difficultyLevel: any, difficultyType: any, type: string) => {
        setQuestionData({ difficultyLevel, difficultyType });
    }
    const setRelevantExam = (relevantExams: any[]) => {
        setQuestionData({ relevantExams, syllabusExams: relevantExams });
    }

    const updateTags = (tags: any[]) => {
        setQuestionData({ tags });
    }
    const updatePreviousYear = (previousExams: any[]) => {
        setQuestionData({ previousExams });   
    }

    const updateSubject = (subjects: any[]) => {      
        setQuestionData({ subjects });
    }

    const updateSecondarySubject = (secondarySubjects: any[]) => {
        setQuestionData({ secondarySubjects });
    }

    const formatPreviousYear = (previousExams: any[]) => {
        const newPreviousExams: any[] = [];
        previousExams.forEach((exams: any) =>
            exams.year.forEach((newYear: any[]) =>
                newPreviousExams.push({ ...exams, year: +newYear })
            )
        );
        return newPreviousExams;
    }

    const saveQuestionData = () => {
        questionDataList.forEach((questionInfo: any) =>
            updateQuestionBenchmarks({ questionId: questionInfo['_id'] })
        );

        let newFormData = createDeepCopy(contentData);
        const conceptCodes: any[] = [];
        const conceptIds: any[] = [];
        if (isParagraphQuestion) {
            newFormData.content.content = questionDataList;
            try {
                newFormData.content.relevantExams = questionDataList[0].relevantExams;
                newFormData.content.difficultyLevel = questionDataList[0].difficultyLevel;
                newFormData.content.settings = questionDataList[0].settings;
                newFormData.content.tags = questionDataList[0].tags;
                newFormData.content.content.forEach((contentInfo: any) => {
                    const { conceptCodes, conceptIds } = convertSubjectIdFromObjectToString(contentInfo.subjects);
                    conceptCodes.push(...conceptCodes);
                    conceptIds.push(...conceptIds);
                    contentInfo.previousExams = formatPreviousYear(contentInfo.previousExams);
                });
                newFormData.content.previousExams = newFormData.content.content[0].previousExams;
            } catch (error) {
            }

        } else {
            newFormData.content = questionDataList[0];
            newFormData.content.previousExams = formatPreviousYear(newFormData.content.previousExams);
            const { conceptCodes, conceptIds } = convertSubjectIdFromObjectToString(newFormData.content.subjects);
            conceptCodes.push(...conceptCodes);
            conceptIds.push(...conceptIds);
        }
        newFormData.content.conceptCode = conceptCodes;
        newFormData.content.conceptIds = conceptIds;
        newFormData.content.conceptCodes = conceptCodes;
        newFormData.content.firstValidatorApproved = true;
        return contentService.saveQuestion(newFormData.content);
    }

    useEffect(() => {
        let contentList =[];
        if (isParagraphQuestion) {
            contentList = getPropertyValue(contentData, 'content.content');
        } else {
            contentList = [getPropertyValue(contentData, 'content') || getDefaultFormData()];
        }
        contentList = createDeepCopy(contentList);
        contentList.forEach((content: any) => content.subjects = []);
        setQuestionDataList(contentList);
        const selectedGoal: any = {};
        contentList.forEach((content: any) =>
            selectedGoal[content._id] = content.relevantExams);
        setCounter(counter + 1);
        setShowConceptAndChapter(true);
    }, [contentData]);

    useEffect(() => {
        checkForMandatoryFields();
        submitValidatorRef.current = saveQuestionData;
    }, [questionData]);

    useEffect(() => {
        setIdealTime({ ...DEFAULT_IDEAL_TIME, value: getPropertyValue(questionData, 'settings.idealTimeToSolve') });
        setRelevantExams(getPropertyValue(questionData, 'relevantExams', []));
    }, [counter]);


    const onChangeIdealTime = (event: any, state?: any) => {
        state = state || idealTime.state;
        let value: any = event ? +getPropertyValue(event, 'target.value', '') : idealTime.value;
        if (REGEX_FOR_NUMBER.test(value)) {
            value = Math.floor(+convertTime(value, getTimerStateForIdealTime(idealTime.state), getTimerStateForIdealTime(state)));
            if (state >= 1 && state <= 3) {
                setIdealTime({ value, state });
                const settings = createDeepCopy(questionData.settings);
                settings.idealTimeToSolve = Math.floor(+convertTime(value, getTimerStateForIdealTime(state), getTimerStateForIdealTime(1)));
                setQuestionData({ settings });
            }
        }
    }

    const setActiveIndex = (questionNumber: any) => {
        setSelectedIndex(questionNumber - 1);
        setCounter(counter + 1);
    }


    return (
        <div>
            <h2 className={classes.heading}>Please fill out the following fields to proceed. </h2>
            {isParagraphQuestion && <QuestionSlider
                totalQuestion={questionDataList}
                setQuestionActive={setActiveIndex}
                activeIndex={selectedIndex + 1}
            />}
            {showConceptAndChapter && <AddConceptOrChapter
                defaultExpanded
                handleFormChange={updateSubject}
                formData={getPropertyValue(questionData, 'subjects', [])}
                goalMandatory
                contentType={CONTENT_TYPE.QUESTION}
                allowSecondarySubjects
                secondarySubjects={getPropertyValue(questionData, 'secondarySubjects', [])}
                handleSecondarySubjectChange={updateSecondarySubject}
            />}
            <AddDifficultyAndSkill
                defaultExpanded={true}
                difficultyLevel={getPropertyValue(questionData, 'difficultyLevel', [])}
                difficultyType={getPropertyValue(questionData, 'difficultyType', [])}
                formData={questionData}
                handleFormChange={setDifficultyAndSkill}
            />
            <SetIdealTime
                defaultExpanded={true}
                idealTime={idealTime}
                onChangeIdealTime={onChangeIdealTime}
            />
            <RelevantExams
                isOptional={true}
                defaultExpanded={true}
                onChangeRelevantExams={setRelevantExam}
            />
            <AddBenchmarking
                defaultExpanded={true}
                questionId={questionId}
                syllabusExams={getPropertyValue(questionData, 'syllabusExams', [])}
                handleSaveBenchmarking={setBenchMarking}
            />
            <PreviousYearQuestion
                defaultExpanded={true}
                questionId={questionId}
                subjects={getPropertyValue(questionData, 'subjects', [])}
                isDisable={(getPropertyValue(questionData, 'masterVariationQuestionId'))}
                handlePreviousExams={updatePreviousYear}
            />
            <AddExtraTags
                formData={getPropertyValue(questionData, 'tags', [])}
                handleFormChange={updateTags}
                defaultExpanded={true}
                contentType={'question'}
                authorType={getPropertyValue(questionData, 'authors', [])}
            />
        </div>
    );
}

const mapStateToProps = (state: any) => {
};

const mapDispatchToProps = {
    setSelectedGoals: questionActions.setSelectedGoals,
    setSpecialPurposes: questionActions.setSpecialPurposes,
    setAllRelevantExams: questionActions.setAllRelevantExams,
    updateQuestionBenchmarks: contentActions.updateQuestionBenchmarks,
    setRelevantExams: questionActions.setRelevantExams,
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(styles)(React.memo(ValidatorFields)));
